/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmergencyMessageSelfCreate
 */
export interface EmergencyMessageSelfCreate {
    /**
     * 
     * @type {string}
     * @memberof EmergencyMessageSelfCreate
     */
    emergency_id: string;
    /**
     * 
     * @type {string}
     * @memberof EmergencyMessageSelfCreate
     */
    content?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmergencyMessageSelfCreate
     */
    message_kind: string;
    /**
     * 
     * @type {number}
     * @memberof EmergencyMessageSelfCreate
     */
    degrees_bearing?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EmergencyMessageSelfCreate
     */
    latitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EmergencyMessageSelfCreate
     */
    longitude?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EmergencyMessageSelfCreate
     */
    meters_per_second_speed?: number | null;
}

/**
 * Check if a given object implements the EmergencyMessageSelfCreate interface.
 */
export function instanceOfEmergencyMessageSelfCreate(value: object): value is EmergencyMessageSelfCreate {
    if (!('emergency_id' in value) || value['emergency_id'] === undefined) return false;
    if (!('message_kind' in value) || value['message_kind'] === undefined) return false;
    return true;
}

export function EmergencyMessageSelfCreateFromJSON(json: any): EmergencyMessageSelfCreate {
    return EmergencyMessageSelfCreateFromJSONTyped(json, false);
}

export function EmergencyMessageSelfCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergencyMessageSelfCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'emergency_id': json['emergency_id'],
        'content': json['content'] == null ? undefined : json['content'],
        'message_kind': json['message_kind'],
        'degrees_bearing': json['degrees_bearing'] == null ? undefined : json['degrees_bearing'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'meters_per_second_speed': json['meters_per_second_speed'] == null ? undefined : json['meters_per_second_speed'],
    };
}

export function EmergencyMessageSelfCreateToJSON(json: any): EmergencyMessageSelfCreate {
    return EmergencyMessageSelfCreateToJSONTyped(json, false);
}

export function EmergencyMessageSelfCreateToJSONTyped(value?: EmergencyMessageSelfCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emergency_id': value['emergency_id'],
        'content': value['content'],
        'message_kind': value['message_kind'],
        'degrees_bearing': value['degrees_bearing'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'meters_per_second_speed': value['meters_per_second_speed'],
    };
}

